<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xml:space="preserve"
    viewBox="0 0 37.4 39.8"
  >
    <path
      d="M8.1 9C6.3 9 4.8 7.5 4.8 5.6s1.5-3.4 3.4-3.4 3.4 1.5 3.4 3.4S10 9 8.1 9zm0-5c-.9 0-1.6.8-1.6 1.6s.7 1.6 1.6 1.6 1.6-.7 1.6-1.6S9 4 8.1 4zM5.4 19c-.5 0-.9-.4-.9-.9v-4.2c0-.5.4-.9.9-.9s.9.4.9.9v4.2c-.1.5-.5.9-.9.9z"
    />
    <path
      d="M3.3 19c-.5 0-.9-.4-.9-.9v-5.7C2.4 10.5 3.9 9 5.8 9h.8l1.5.5L9.6 9h1c.5 0 .9.4.9.9s-.4.9-.9.9h-.5l-1.7.6c-.2.1-.4.1-.6 0l-1.7-.6h-.3c-.9 0-1.6.7-1.6 1.6v5.7c-.1.5-.4.9-.9.9z"
    />
    <path
      d="M5.4 19c-.5 0-.9-.4-.9-.9v-4.2c0-.5.4-.9.9-.9s.9.4.9.9v4.2c-.1.5-.5.9-.9.9zM29.3 9c-1.9 0-3.4-1.5-3.4-3.4s1.5-3.4 3.4-3.4 3.4 1.5 3.4 3.4S31.1 9 29.3 9zm0-5c-.9 0-1.6.7-1.6 1.6s.7 1.6 1.6 1.6c.9 0 1.6-.7 1.6-1.6S30.2 4 29.3 4zM32 19c-.5 0-.9-.4-.9-.9v-4.2c0-.5.4-.9.9-.9s.9.4.9.9v4.2c0 .5-.4.9-.9.9z"
    />
    <path
      d="M34.1 19c-.5 0-.9-.4-.9-.9v-5.7c0-.9-.7-1.6-1.6-1.6h-.4l-1.7.6c-.2.1-.4.1-.6 0l-1.7-.6h-.5c-.5 0-.9-.4-.9-.9s.5-.9 1-.9h1l1.5.5 1.5-.5h.8c1.9 0 3.4 1.5 3.4 3.4v5.7c0 .5-.4.9-.9.9z"
    />
    <path
      d="M32 19c-.5 0-.9-.4-.9-.9v-4.2c0-.5.4-.9.9-.9s.9.4.9.9v4.2c0 .5-.4.9-.9.9zM18.7 7.7c-2.1 0-3.8-1.7-3.8-3.8S16.6 0 18.7 0s3.8 1.7 3.8 3.8-1.7 3.9-3.8 3.9zm0-5.9c-1.1 0-2.1.9-2.1 2.1S17.5 6 18.7 6s2.1-.9 2.1-2.1-1-2.1-2.1-2.1zM15.4 19c-.5 0-.9-.4-.9-.9v-4.8c0-.5.4-.9.9-.9s.9.4.9.9v4.8c0 .5-.4.9-.9.9zm6.6 0c-.5 0-.9-.4-.9-.9v-4.8c0-.5.4-.9.9-.9s.9.4.9.9v4.8c0 .5-.4.9-.9.9z"
    />
    <path
      d="M24.5 19c-.5 0-.9-.4-.9-.9v-6.6c0-1.2-.9-2.1-2.1-2.1H21l-2 .6c-.2.1-.4.1-.6 0l-2-.7h-.5c-1.2 0-2.1.9-2.1 2.1V18c0 .5-.4.9-.9.9s-.9-.4-.9-.9v-6.6c0-2.1 1.7-3.9 3.9-3.9h.9l1.9.6 1.9-.6h.9c2.1 0 3.9 1.7 3.9 3.9V18c-.1.6-.5 1-.9 1z"
    />
    <path
      d="M22 19c-.5 0-.9-.4-.9-.9v-4.8c0-.5.4-.9.9-.9s.9.4.9.9v4.8c0 .5-.4.9-.9.9zm-6.6 0c-.5 0-.9-.4-.9-.9v-4.8c0-.5.4-.9.9-.9s.9.4.9.9v4.8c0 .5-.4.9-.9.9zm3.3 20.8h-.2C8.3 39.7 0 31.3 0 21.2c0-.5.4-.9.9-.9s.9.4.9.9c0 9.2 7.5 16.8 16.7 16.9h.4c9.2-.1 16.7-7.7 16.7-16.9 0-.5.4-.9.9-.9s.9.4.9.9c0 10.2-8.3 18.6-18.4 18.7h-.3z"
    />
    <path
      d="M18.7 39.8c-.5 0-.9-.4-.9-.9V21.2c0-.5.4-.9.9-.9s.9.4.9.9V39c0 .5-.4.8-.9.8z"
    />
    <path
      d="M18.7 39.8h-.2c-3.4-.2-6.4-3.5-8.1-9-.9-2.9-1.4-6.2-1.4-9.7 0-.5.4-.9.9-.9s.9.4.9.9c0 3.3.5 6.5 1.3 9.2 1.5 4.6 3.9 7.6 6.5 7.7h.4c2.5-.1 5-3.1 6.5-7.7.9-2.7 1.3-5.9 1.3-9.2 0-.5.4-.9.9-.9s.9.4.9.9c0 3.5-.5 6.8-1.4 9.7-1.7 5.4-4.7 8.8-8.1 9h-.4z"
    />
    <path
      d="M36.5 22H.9c-.5 0-.9-.4-.9-.8 0-.5.4-.9.9-.9h35.6c.5 0 .9.4.9.9 0 .4-.4.8-.9.8zM5.8 34.3c-.3 0-.5-.1-.7-.3-.3-.4-.3-.9.1-1.2 1.5-1.2 3.4-2.3 5.6-3 4.8-1.5 10.8-1.5 15.6 0 2.2.7 4.1 1.7 5.6 2.9.4.3.4.9.1 1.2-.3.4-.9.4-1.2.1-1.3-1.1-3.1-2-5.1-2.6-4.4-1.4-10.1-1.4-14.5 0-2 .6-3.7 1.6-5.1 2.6 0 .2-.2.3-.4.3z"
    />
  </svg>
</template>
